import useGlobalConfig from "@/store/global";

const Panzyga = () => {
  const { themeColor } = useGlobalConfig();
  return (
    <>
      <div className="rounded-md bg-[#f3f3f3] p-8 pt-4">
        <div className="my-6 border-b-2 border-sky-700 border-dotted" 
          style={{ borderColor: themeColor }} />

        <div className="font-bold">
          INDICATIONS AND IMPORTANT SAFETY INFORMATION FOR PANZYGA IMMUNE GLOBULIN INTRAVENOUS (Human) – IFAS 10% LIQUID PREPARATION
        </div>

        <div className="mt-6 px-4 py-2 border border-black">
          <p className="font-bold">WARNING: THROMBOSIS, RENAL DYSFUNCTION, AND ACUTE RENAL FAILURE</p>

          <p className="mt-2">
            Please click&nbsp;
            <a
              target="_blank"
              href="/panzyga-full-prescribing-information.pdf"
              className="underline"
              rel="noopener noreferrer"
            >
              here
            </a>
            &nbsp;for Full Prescribing Information, including BOXED WARNING.
          </p>

          <ul className="list-disc ml-4 mt-4 font-bold">
            <li className="my-2">
              Thrombosis may occur with immune globulin intravenous (IGIV) products, including Panzyga. Risk factors may include: advanced age, prolonged immobilization, hypercoagulable conditions, history of venous or arterial thrombosis, use of estrogens, indwelling central vascular catheters, hyperviscosity, and cardiovascular risk factors. Thrombosis may occur in the absence of known risk factors.
            </li>
            <li className="my-2">
              Renal dysfunction, acute renal failure, osmotic nephrosis, and death may occur in predisposed patients who receive IGIV products, including Panzyga. Patients predisposed to renal dysfunction include those with a degree of pre-existing renal insufficiency, diabetes mellitus, age greater than 65, volume depletion, sepsis, paraproteinemia, or patients receiving known nephrotoxic drugs. Renal dysfunction and acute renal failure occur more commonly in patients receiving IGIV products containing sucrose. Panzyga does not contain sucrose.
            </li>
            <li className="my-2">
              For patients at risk of thrombosis, renal dysfunction, or acute renal failure, administer Panzyga at the minimum dose and infusion rate practicable. Ensure adequate hydration in patients before administration. Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at risk for hyperviscosity. [see Full Prescribing Information, Warnings and Precautions (5.2, 5.4)]
            </li>
          </ul>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Indications and Usage</p>
          <p className="my-2">
            Panzyga (Immune Globulin Intravenous [Human] - ifas) is indicated for the treatment of primary humoral immunodeficiency (PI) in patients 2 years of age and older; this includes, but is not limited to, congenital agammaglobulinemia, common variable immunodeficiency, X-linked agammaglobulinemia, Wiskott-Aldrich syndrome, and severe combined immunodeficiencies; 
            chronic immune thrombocytopenia (cITP) in adults to raise platelet counts to control or prevent bleeding; 
            and chronic inflammatory demyelinating polyneuropathy (CIDP) in adults to improve neuromuscular disability and impairment.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Contraindications</p>
          <p className="my-2">
            PANZYGA is contraindicated in patients who have a history of severe systemic hypersensitivity reactions, such as anaphylaxis, to human immunoglobulin and in IgA-deficient patients with antibodies against IgA and history of hypersensitivity.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Warnings and Precautions</p>
          <p>
            Monitor renal function, including blood urea nitrogen and serum creatinine, and urine output in patients at risk of developing acute renal failure.
            Hyperproteinemia, increased serum osmolarity, and hyponatremia may occur in patients receiving PANZYGA.
            Aseptic meningitis syndrome may occur in patients receiving PANZYGA, especially with high doses or rapid infusion.
            Hemolysis that is either intravascular or due to enhanced red blood cell sequestration can develop subsequent to PANZYGA treatments. Risk factors for hemolysis include high doses and non-O-blood group. Closely monitor patients for hemolysis and hemolytic anemia.
            Monitor patients for pulmonary adverse reactions (transfusion-related acute lung injury [TRALI]).
            Monitor blood pressure prior to, during, and following PANZYGA infusion.
            Carefully consider the relative risks and benefits before prescribing the high dose regimen (for cITP) in patients at increased risk of volume overload.
            PANZYGA is made from human plasma and may contain infectious agents, e.g. viruses and theoretically, the Creutzfeldt-Jakob disease agent.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Adverse Reactions</p>
          <ul>
            <li className="my-2">
              PI – The most common adverse reactions (≥5% study subjects) were headache, nausea, fever, fatigue, and abdominal pain.
            </li>
            <li className="my-2">
              cITP in adults – The most common adverse reactions (≥5% study subjects) were headache, fever, nausea, vomiting, dizziness, and anemia.
            </li>
            <li className="my-2">
              CIDP in adults – The most common adverse reactions reported in greater than 5% of subjects were: headache, fever, dermatitis, and blood pressure increase. The risk information provided here is not comprehensive; see Full Prescribing Information and Boxed Warning for PANZYGA. 
            </li>
          </ul>
        </div>

        <div className="mt-8">
          <p className="my-2 font-bold">
            <a
              target="_blank"
              href="/panzyga-full-prescribing-information.pdf"
              className="!text-sky-700 hover:underline"
              rel="noopener noreferrer"
            >
              Please click here for Full Prescribing Information.
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Panzyga;
